import React, { useContext } from 'react';
import BarChart from 'components/@common/Charts/BarChart';
import { PrintViewContext } from '../../../../providers/PrintViewProvider';
import { Box, Typography } from '@material-ui/core';
import Popover from 'components/@common/Popover';

type Props = {
  attempt1: number[];
  attempt2: number[];
  attempt1SeriesTitle: string;
  attempt2SeriesTitle: string;
  title: string;
  labels: string[];
  loading?: boolean;
  yAxisText?: string;
  colors?: string[];
  onClick?: (index: number) => void;
  helpText: string;
  toolTipText?: string;
};

const ByQuestionStudentChart: React.FC<Props> = ({
  attempt1,
  attempt2,
  attempt1SeriesTitle,
  attempt2SeriesTitle,
  title,
  yAxisText,
  labels,
  colors = ['#338AC6', '#F6B247'],
  onClick,
  helpText,
  toolTipText
}) => {
  const { fullChartWidth } = useContext(PrintViewContext);
  const series = [
    ...(attempt2?.length > 0
      ? [
          {
            name: attempt2SeriesTitle,
            data: attempt2
          }
        ]
      : []),
    ...(attempt1?.length > 0
      ? [
          {
            name: attempt1SeriesTitle,
            data: attempt1
          }
        ]
      : [])
  ];

  return (
    <Box paddingBottom={2}>
      <Box marginBottom="24px">
        <Popover description={helpText}>
          <Typography style={{ fontSize: 24, fontWeight: 500 }}>{title}</Typography>
        </Popover>
      </Box>
      <BarChart
        height={250}
        width={fullChartWidth}
        onClick={onClick}
        series={series}
        options={{
          plotOptions: {
            bar: {
              columnWidth: '25%'
            }
          },
          colors,
          yaxis: {
            labels: {
              formatter: (value: any) => value
            },
            floating: false,
            decimalsInFloat: 0,
            title: {
              offsetX: -2,
              text: yAxisText,
              style: {
                color: '#373D3F',
                fontSize: '12px',
                fontWeight: 700,
                fontFamily: 'futura-pt'
              }
            }
          },
          xaxis: {
            categories: labels,
            labels: {
              offsetY: -4,
              style: {
                colors: '#373D3F',
                fontSize: '10px',
                fontFamily: 'futura-pt'
              }
            },
            axisTicks: { show: false }
          },
          ...(toolTipText && {
            tooltip: {
              y: {
                title: {
                  formatter: (value: any) => {
                    return `${toolTipText}:`;
                  }
                }
              }
            }
          }),
          legend: {
            offsetY: 2,
            horizontalAlign: 'left'
          },

          dataLabels: { enabled: false }
        }}
      />
    </Box>
  );
};

export default React.memo(ByQuestionStudentChart);
